export default __webpack_public_path__ + "static/media/red-1.0b800ff7.png";